module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-align-left",
    class: ['is-' + _vm.type]
  }, [_c('div', {
    staticClass: "u-flex--x u-marg-b-md"
  }, [(_vm.type === 'twitter') ? _c('img', {
    staticClass: "u-marg-r-sm",
    attrs: {
      "src": require("../../../assets/icon/icon-twitter--hexa-red--big.png"),
      "width": "49",
      "height": "56",
      "alt": "Twitter",
      "title": "Twitter"
    },
    on: {
      "load": function($event) {
        _vm.onLoad()
      }
    }
  }) : (_vm.type === 'instagram') ? _c('img', {
    staticClass: "u-marg-r-sm",
    attrs: {
      "src": require("../../../assets/icon/icon-instagram--hexa-red--big.png"),
      "width": "49",
      "height": "56",
      "alt": "Instagram",
      "title": "Instagram"
    },
    on: {
      "load": function($event) {
        _vm.onLoad()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  }, [_c('span', {
    staticClass: "u-uppercase u-block t-text--sm u-marg-t-xxxs t-lspacing--sm u-color--gray-ldark u-bold",
    domProps: {
      "innerHTML": _vm._s(this.date)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "u-inline-block t-text--lg u-marg-t-xxxs u-color--white",
    attrs: {
      "href": _vm.content.author.link
    }
  }, [_vm._v("@" + _vm._s(_vm.content.author.name))])])]), _vm._v(" "), (_vm.img !== '') ? _c('app-img', {
    staticClass: "c-hub-item__img u-marg-b-xs",
    attrs: {
      "src": _vm.img
    },
    on: {
      "load": _vm.onLoad
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text !== '') ? _c('p', {
    staticClass: "c-hub__description u-marg-b-lg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-hub__line u-fit-w u-marg-b-xl"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce29810"}!./src/scripts/components/app-hub-item/template.html
// module id = 906
// module chunks = 0